export interface CandidateRole {
    value: string;
    label: string;
}

export const CANDIDATE_ROLES: CandidateRole[] = [
    { value: '', label: 'All Roles' },
    { value: 'Software Developer', label: 'Software Developer' },
    { value: 'Business Analyst', label: 'Business Analyst' },
    { value: 'Data Scientist', label: 'Data Scientist' },
    { value: 'DevOps Engineer', label: 'DevOps Engineer' },
    { value: 'UI/UX Designer', label: 'UI/UX Designer' }
];


export interface CandidateLocation {
    value: string;
    label: string;
}

export const CANDIDATE_LOCATIONS: CandidateLocation[] = [
    { value: '', label: 'All Cities' },
    { value: 'city 1', label: 'City 1' },
    { value: 'city 2', label: 'City 2' },
    { value: 'city 3', label: 'City 3' }
];